module.exports = __webpack_public_path__ + "static/img/11.2ae7ae7c.png";